import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import firebase from "../utils/firebase";
import "./header.css";

function Header() {
  const [isLoggedIn, setLoggedIn] = useState(false);
  useEffect(() => {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        setLoggedIn(true);
      }
    });
  }, []);

  const logout = async () => {
    await firebase.auth().signOut();
    setLoggedIn(false);
  };

  return (
    <div id="header-wrapper">
      <div id="header">
        <Link to="/">
          <p id="link-button">Home</p>
        </Link>
        <Link to="/serve">
          <p id="link-button"> Serve </p>
        </Link>
        <Link to="/faq">
          <p id="link-button"> FAQ </p>
        </Link>
        <Link to="/resources">
          <p id="link-button"> Resources </p>
        </Link>
        {!isLoggedIn ? (
          <Link to="/login">
            <p id="link-button"> Login </p>
          </Link>
        ) : (
          <></>
        )}
        {isLoggedIn ? (
          <p id="login-link-button" onClick={logout}>
            Logout
          </p>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}

export default Header;
